import commonStyles from "utility/ui/common";

const styles = {
  closeBtn: (isMobile) => (isMobile ? commonStyles.controlBtnMobile : commonStyles.controlBtn),
};

export default styles;
